import React from 'react';
import './Chapters.scss';
import TextWrapPhoto from '../Photos/TextWrapPhoto';
import wrapPhoto2 from '../../Assets/wrapPhoto2.jpg';
import PullQuote from '../PullQuote/PullQuote';

function Chapter5() {
  const photoData = {
    imgSrc: wrapPhoto2,
    caption: 'Related products used in the Work For Humankind Project',
    float: 'right' //pass in "right" or "left"
  };
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__title">A Cutting-Edge Partnership</p>
        <p className="chapter__paragraph">
          Ferland and his team are used to projects that push the limits of computing in service of
          human good. For example, they are using 5G technology to transform Barcelona into a{' '}
          <a
            href="https://www.lenovo.com/us/en/resources/streams/customer-stories?storypopup=smart-city-barcelona-lf-video"
            target="_blank"
            rel="sponsored"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            smart city of the future.
          </a>
        </p>
      </section>
      <PullQuote
        quote={
          "“Smarter technology means helping our customers solve some of humanity's greatest challenges,” Ferland says. And solving those challenges means the team is working, quite literally, at the edge."
        }
      />
      <section className="chapter">
        <div>
          <TextWrapPhoto photoData={photoData} />
          <p className="chapter__paragraph">
            As part of its effort to redefine Work From Home as Work For Humankind, Lenovo donated
            and installed an island workspace with a range of its powerful devices and solutions,
            including Lenovo ThinkPad, ThinkBook, Legion, and Yoga PCs; Motorola edge smartphones;
            ThinkSmart collaboration devices; ThinkReality augmented reality smart glasses, and
            more. Then volunteers were invited from around the world to take part in a
            once-in-a-lifetime opportunity—to work their day jobs completely remotely using Lenovo’s
            tech and then volunteer their time and skills for the island’s conservation effort.
          </p>
          <p className="chapter__paragraph">
            In addition, Lenovo upgraded the island’s internet to a 200-Mbps satellite connection.
            Yet even with the Island’s upgraded internet connection, it was impractical to send
            massive amounts of data from all 70 high-definition cameras to the cloud for analysis.
          </p>
          <p className="chapter__paragraph">
            Ferland’s team knew they needed to bring supercomputing power to Robinson Crusoe Island,
            where the data was being created. But installing a data center wasn’t a feasible
            solution because of the island’s extreme temperatures and humidity. What’s more, the
            salt in the ocean air would be extremely corrosive to conventional data centers.
          </p>
        </div>
      </section>
      <section className="chapter">
        <p className="chapter__paragraph">
          Because their ecosystems are so fragile, islands have become the epicenters of extinction.
          In fact, the overwhelming majority of reptile, bird, amphibian, and mammal extinctions
          have occurred on islands, and a staggering 86% of those recorded extinctions have been
          caused by invasive species.
        </p>
      </section>
    </>
  );
}

export default Chapter5;
